// The desk skeleton (shell-ia §15.3; replaces os/AppSkeleton.tsx for ECONIC): the new desk geometry under the host header — the 32 px
// underline view tabs and the 3 / 6 / 3 card grid, fluid, body-shaped, static `--fill` shapes (APPLE-SPEC §7 10.16, §11: no shimmer, no
// spinner) — with `data-app-skeleton` and `aria-busy`, and after 8 s the line that the first open takes a little longer. It fills the
// frame's box and goes in a 120 ms crossfade when the desk is ready. WP-DESK-HOST.
import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { useTranslation } from "@ncp/i18n";
import "./desks.css";

const SLOW_MS = 8000;

export function DeskSkeleton() {
  const { t } = useTranslation();
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setSlow(true), SLOW_MS);
    return () => clearTimeout(timer);
  }, []);
  const card = (lines: string[], tall = false, key?: string) => (
    <div className={tall ? "card tall" : "card"} key={key}>
      <div className="ln h" />
      {lines.map((w, i) => <div key={i} className={`ln ${w}`} />)}
    </div>
  );
  return (
    <div className="es-dskel" data-app-skeleton="" aria-busy="true" role="status" aria-label={t("assistant:econic.desks.loading.label")}>
      <div className="tabs" aria-hidden><i /><i /><i /><i /></div>
      <div className="grid" aria-hidden>
        <div className="col side">{card(["w85", "w70", "w55", "w70"], false, "a")}{card(["w70", "w40"], true, "b")}</div>
        <div className="col">{card(["w85", "w70", "w85", "w55", "w70", "w40"], true, "c")}</div>
        <div className="col end">{card(["w55", "w85", "w40"], false, "d")}{card(["w70", "w55"], true, "e")}</div>
      </div>
      {slow ? (
        <p className="slow">
          <Clock aria-hidden width={14} height={14} />
          {t("assistant:econic.desks.loading.slow")}
        </p>
      ) : null}
    </div>
  );
}
